module.exports = __webpack_public_path__ + "img/transac_illu.f921e07b.png";